<template>
  <div id="app">
    <v-app id="inspire">
      <v-content v-if="!unsuscribed">
        <v-container fluid fill-height>
          <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
              <v-spacer></v-spacer>
              <v-card class="text-center font" id="petfound">
                <v-col cols="12">
                  <h2>Información de mi dueño</h2>
                  <v-list three-line>
                    <v-divider />

                    <v-list-item>
                      <v-list-item-avatar>
                        <!--suppress HtmlUnknownTarget -->
                        <v-img
                          :src="
                            petDetail.owner.userprofile.picture === null
                              ? imgAvatar
                              : petDetail.owner.userprofile.picture
                          "
                        />
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title
                          v-html="
                            `<strong>${petDetail.owner.name} ${petDetail.owner.lastName}</strong>`
                          "
                        ></v-list-item-title>
                        <div
                          style="text-align: left"
                          v-if="petDetail.owner.userprofile.shareProfile"
                          v-html="getOwnerAddress()"
                        ></div>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider />

                    <v-subheader>
                      <div style="text-align: left">
                        Teléfono: {{ petDetail.owner.phoneNumber }}
                        <br />
                        Email:
                        {{ petDetail.owner.email }}
                      </div>
                    </v-subheader>
                  </v-list>
                </v-col>
                <v-card-actions>
                  <v-row align="center" justify="center">
                    <div>
                      <h4 style="color: #01579b">Ayúdame a regresar</h4>
                      <v-btn
                        class="mx-2"
                        fab
                        dark
                        color="green"
                        @click.prevent="sendWsp"
                      >
                        <v-icon style="font-size: 40px;">mdi-whatsapp</v-icon>
                      </v-btn>

                      <v-btn
                        class="mx-2"
                        fab
                        dark
                        color="orange"
                        @click.prevent="sendCall"
                      >
                        <v-icon>mdi-phone</v-icon>
                      </v-btn>
                    </div>
                  </v-row>
                </v-card-actions>

                <v-spacer></v-spacer>
                <div>
                  <!-- <v-avatar
                    size="82"
                    class="mb-5 mt-5"
                  >-->
                  <!--suppress HtmlUnknownTarget -->
                  <v-img
                    :src="
                      petDetail.image === null ? imgPetAvatar : petDetail.image
                    "
                    aspect-ratio="1.4"
                    contain
                  ></v-img>
                  <!-- </v-avatar> -->
                </div>

                <div class="name">
                  <h1>{{ petDetail.name }}</h1>
                </div>
                <v-card-text>
                  <v-row align="center" justify="space-between">
                    <div class="items_pet">
                      <div>
                        <h2>Raza</h2>
                      </div>
                      <p>
                        <strong>{{ petDetail.race }}</strong>
                      </p>
                    </div>
                    <div class="items_pet">
                      <div>
                        <h2>Cumpleaños</h2>
                      </div>
                      <p>
                        <strong>{{ petDetail.dateBirth }}</strong>
                      </p>
                    </div>
                    <div class="items_pet">
                      <div>
                        <h2>Edad</h2>
                      </div>
                      <p>
                        <strong>{{ petDetail.age }}</strong>
                      </p>
                    </div>
                    <div class="items_pet">
                      <div>
                        <h2>Género</h2>
                      </div>
                      <p>
                        <strong>{{ petDetail.gender }}</strong>
                      </p>
                    </div>
                    <div class="items_pet">
                      <div>
                        <h2>Especie</h2>
                      </div>

                      <p>
                        <strong>{{ petDetail.species }}</strong>
                      </p>
                    </div>
                  </v-row>

                  <!-- Owner info -->
                  <v-row
                    align="center"
                    justify="space-between"
                    v-if="petDetail.owner.userprofile.shareProfile"
                  >
                  </v-row>
                </v-card-text>

                <div id="info"></div>
                <v-expand-transition>
                  <div>
                    <v-divider></v-divider>

                    <v-card-text>
                      <div class="items_pet" v-if="petDetail.sterilized">
                        <div>
                          <h3>¿Está esterilizado?</h3>
                        </div>
                        <p>
                          <strong>{{ petDetail.sterilized }}</strong>
                        </p>
                      </div>
                      <div class="items_pet">
                        <div>
                          <h3>¿Está vacunado?</h3>
                        </div>
                        <p>
                          <strong>{{ petDetail.vaccinated }}</strong>
                        </p>
                      </div>
                      <div class="items_pet" v-if="petDetail.coexistAnimals">
                        <div>
                          <h3>¿Convive con otros animales?</h3>
                        </div>
                        <p>
                          <strong>{{ petDetail.coexistAnimals }}</strong>
                        </p>
                      </div>
                      <div
                        class="items_pet"
                        v-if="petDetail.coexistAnimalsDescription"
                      >
                        <div>
                          <h3>¿Cuáles?</h3>
                        </div>
                        <p>
                          <strong>{{
                            petDetail.coexistAnimalsDescription
                          }}</strong>
                        </p>
                      </div>
                      <div
                        class="items_pet"
                        v-if="petDetail.coexistLittleChill"
                      >
                        <div>
                          <h3>¿Convive con niños pequeños?</h3>
                        </div>
                        <p>
                          <strong>{{ petDetail.coexistLittleChill }}</strong>
                        </p>
                      </div>

                      <div class="items_pet" v-if="petDetail.coexistAncient">
                        <div>
                          <h3>¿Convive con adultos mayores?</h3>
                        </div>
                        <p>
                          <strong>{{ petDetail.coexistAncient }}</strong>
                        </p>
                      </div>

                      <div class="items_pet" v-if="petDetail.sickness">
                        <div>
                          <h3>¿Padece alguna enfermedad?</h3>
                        </div>
                        <p>
                          <strong>{{ petDetail.sickness }}</strong>
                        </p>
                      </div>
                      <div
                        class="items_pet"
                        v-if="petDetail.sicknessDescription"
                      >
                        <div>
                          <h3>¿Cuál?</h3>
                        </div>
                        <p>
                          <strong>{{ petDetail.sicknessDescription }}</strong>
                        </p>
                      </div>
                      <div class="items_pet" v-if="petDetail.allergies">
                        <div>
                          <h3>¿Tiene alguna alergia?</h3>
                        </div>
                        <p>
                          <strong>{{ petDetail.allergies }}</strong>
                        </p>
                      </div>
                      <div
                        class="items_pet"
                        v-if="petDetail.allergiesDescription"
                      >
                        <div>
                          <h3>¿A que?</h3>
                        </div>
                        <p>
                          <strong>{{ petDetail.allergiesDescription }}</strong>
                        </p>
                      </div>
                      <div class="items_pet" v-if="petDetail.notes">
                        <div>
                          <h3>Notas:</h3>
                        </div>
                        <p>
                          <strong>{{ petDetail.notes }}</strong>
                        </p>
                      </div>
                    </v-card-text>
                  </div>
                </v-expand-transition>
                <v-col>
                  <v-row justify="center">
                    <router-link to="/">
                      <v-img
                        :src="require('@/assets/ObiPetsLogo.svg')"
                        width="80"
                        height="80"
                        contain
                      ></v-img>
                    </router-link>
                  </v-row>
                </v-col>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
      <v-content class="nopet font" v-if="unsuscribed">
        <v-container fluid fill-height class="text-center">
          <v-row justify="center">
            <v-col>
              <p style="color: #fff">
                Lo sentimos, está placa ha sido dada de baja.
              </p>
              <v-row justify="center">
                <router-link to="/">
                  <v-img
                    :src="require('@/assets/ObiPetsLogo.svg')"
                    width="80"
                    height="80"
                    contain
                  ></v-img>
                </router-link>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-content>
      <v-snackbar v-model="snackbar">
        {{ snackbarText }}
        <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </v-app>
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      unsuscribed: false,
      showInfo: false,
      imgAvatar:
        "https://f0.pngfuel.com/png/489/569/youtube-user-desktop-computer-icons-sketchup-flat-people-png-clip-art.png",
      imgPetAvatar:
        "https://cdn.dribbble.com/users/6356/screenshots/1280637/flat-dog.png",
      snackbar: false,
      snackbarText: "",
      petCode: null,
      longitude: null,
      latitude: null,
      petDetail: {
        name: "",
        species: "",
        gender: "",
        dateBirth: "",
        age: "",
        race: "",
        sterilized: "",
        vaccinated: "",
        coexistAnimals: "",
        coexistAnimalsDescription: "",
        coexistLittleChill: "",
        coexistAncient: "",
        sickness: "",
        sicknessDescription: "",
        allergies: "",
        allergiesDescription: "",
        notes: "",
        image: this.imgPetAvatar,
        owner: {
          id: "",
          username: "",
          name: "",
          lastName: "",
          email: "",
          phoneNumber: "",
          userprofile: {
            id: "",
            picture: this.imgAvatar,
            street: "",
            extNum: "",
            intNum: "",
            postalCode: "",
            settlement: "",
            city: "",
            municipality: "",
            estate: "",
            shareProfile: false,
          },
        },
      },
    };
  },
  mounted() {
    let queryString = new URLSearchParams(location.search);
    this.petCode = queryString.get("chaws");
    // Obtiene PetCode Object para encontrar la mascota asociada al QR
    this.getPetCode({ petCode: this.petCode })
      .then((res) => {
        if (res.pet.isActive == true) {
          this.getPet(res.pet.id)
            .then((res) => {
              this.petDetail = res;
              this.getLocation();
            })
            .catch((err) => {
              this.snackbar = true;
              if (err.response) {
                this.snackbarText = err.response.data;
              } else {
                this.snackbarText = err;
              }
            });
        } else {
          this.unsuscribed = true;
          // Encuentra la mascota asociada, por lo que consulta su información completa
        }
      })
      .catch((err) => {
        this.snackbar = true;
        if (err.response) {
          this.snackbarText = err.response.data;
        } else {
          this.snackbarText = err;
          this.$router.push({
            name: "thisCouldBe",
          });
        }
      });
  },
  methods: {
    ...mapActions("pets", {
      getPetCode: "getPetCode",
      getPet: "getPet",
      setPetCoords: "setPetCoords",
    }),
    sendWsp() {
      let message = `¡Hola! Encontré a ${this.petDetail.name} en esta ubicación : \n https://www.google.com/maps/search/?api=1&query=${this.latitude},${this.longitude} \n \n ¡Escríbeme!`;
      let ownerPhone = this.petDetail["owner"]["phoneNumber"];
      const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(
        message
      )}&phone=${encodeURIComponent(ownerPhone)}`;
      window.open(url);
    },
      sendCall() {
            let ownerPhone = this.petDetail["owner"]["phoneNumber"];
            ownerPhone=ownerPhone.replace("Phone:","");
            window.location.href="tel://"+ownerPhone;
      
    },
    errSavePosition(err) {
      this.snackbarText = "ERROR(" + err.code + "): " + err.message;
      let data = {
        latitude: "",
        longitude: "No hay datos",
        petId: this.petDetail.id,
      };
      this.setPetCoords(data);
    },
    savePosition(position) {
      this.longitude = position.coords.longitude;
      this.latitude = position.coords.latitude;
      let data = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        petId: this.petDetail.id,
      };
      this.setPetCoords(data);
    },
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.savePosition,
          this.errSavePosition
        );
      } else {
        this.snackbar = true;
        this.snackbarText =
          "La geolocalización no es soportada en este navegador.";
      }
    },
    getOwnerAddress() {
      if (this.petDetail.owner.userprofile.settlement !== "") {
        let address = `${this.petDetail.owner.userprofile.street} ext ${this.petDetail.owner.userprofile.extNum}`;

        // Numero interno
        if (
          this.petDetail.owner.userprofile.intNum !== "" ||
          this.petDetail.owner.userprofile.intNum !== null
        ) {
          address += `, int ${this.petDetail.owner.userprofile.intNum}`;
        }
        // Colonia
        if (
          this.petDetail.owner.userprofile.settlement !== "" ||
          this.petDetail.owner.userprofile.settlement !== null
        ) {
          address += `, Col. ${this.petDetail.owner.userprofile.settlement}`;
        }
        // Ciudad
        if (
          this.petDetail.owner.userprofile.city !== "" ||
          this.petDetail.owner.userprofile.city !== null
        ) {
          address += `, Cd. ${this.petDetail.owner.userprofile.city}`;
        }

        // Municipio
        if (
          this.petDetail.owner.userprofile.municipality !== "" ||
          this.petDetail.owner.userprofile.municipality !== null
        ) {
          address += `, ${this.petDetail.owner.userprofile.municipality}`;
        }

        // Estado
        if (
          this.petDetail.owner.userprofile.estate !== "" ||
          this.petDetail.owner.userprofile.estate !== null
        ) {
          address += `, ${this.petDetail.owner.userprofile.estate}`;
        }

        // Código postal
        if (
          this.petDetail.owner.userprofile.postalCode !== "" ||
          this.petDetail.owner.userprofile.postalCode !== null
        ) {
          address += `, CP. ${this.petDetail.owner.userprofile.postalCode}`;
        }

        return address;
      } else {
        let message = "No hay mas información disponible por el momento.";
        return message;
      }
    },
    internalLink() {
      if (this.showInfo == true) {
        this.showInfo = false;
      } else {
        this.showInfo = true;
        this.$vuetify.goTo("#info", {
          duration: 400,
          offset: 0,
          easing: "easeInOutCubic",
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.info {
  label {
    background-color: #325784;
    padding: 5px;
  }
}
.font {
  font-family: "Kaleko", sans-serif;
}
.nopet {
  background-image: url("../../assets/img/backgrounds/fondoazul.png");
  background-position: center center;
  background-size: cover;
}

#petfound {
  background-image: url("../../assets/img/backgrounds/fondoblanco.png");
  background-size: cover;
}
.name {
  width: 50%;
  margin: 15px 0 0 25%;
  h1 {
    color: #fff;
    background-color: #a7c84b;
    height: inherit;

    border-radius: 10px 10px 10px 10px;
    -moz-border-radius: 10px 10px 10px 10px;
    -webkit-border-radius: 10px 10px 10px 10px;
    border: 0px solid #000000;
  }
}
.items_pet {
  div {
    background-color: #a7c84b;
    height: inherit;
    width: inherit;
    border-radius: 5px;
    border: 0px solid #000000;
    margin: 5px;
  }
  h2 {
    color: #fff;
    margin: 0 10px 0 10px;
  }
  p {
    color: #568b3f;
  }
}

.v-list--three-line .v-list-item .v-list-item__subtitle,
.v-list-item--three-line .v-list-item__subtitle,
.v-list-item__title {
  text-align: left !important;
}
</style>
